import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { MasterBrand } from "./master-brands.entity";


@Entity('brands_trims')
export class BrandsTrims {
  @PrimaryGeneratedColumn("increment", { name: 'brands_trims_id' })
  brandsTrimsId: number;

  @Column("int", {
    nullable: false,
    name: "master_brand_id"
  })
  masterBrandId: number;

  @Column("int", {
    nullable: false,
   name: "trims_id"
  })
  trimsId: number;



@ManyToOne(type => MasterBrand, info => info.trimsInfo, { nullable: true })
@JoinColumn({ name: 'master_brand_id' })
brandsInfo?: MasterBrand;
}